import React from "react";
import { Route, Switch } from "react-router-dom";
// import Inbox from "./inbox/index";
import View from "./list";
import Update from "./update";
import Creacte from "./create";
// import multipalImage from "./creactEditeBrand/multipalImage";
import "./index.css";
const Production = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.url}/add`} component={Creacte} />
      {/* <Route path={`${match.url}/:categoryId/update`} component={Update} /> */}
      <Route path={`${match.url}/:staffMemberStatus`} component={View} />
    </Switch>
  );
};

export default Production;
